import { render, staticRenderFns } from "./SalesCouponList.vue?vue&type=template&id=565ffd6c&scoped=true"
import script from "./SalesCouponList.vue?vue&type=script&lang=js"
export * from "./SalesCouponList.vue?vue&type=script&lang=js"
import style0 from "./SalesCouponList.vue?vue&type=style&index=0&id=565ffd6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565ffd6c",
  null
  
)

export default component.exports